module.exports = __webpack_public_path__ + "static/media/zippyclip-1.e1090bde.jpg";